import React, { useState } from 'react';
import { DrawerFilter } from './DrawerFilter';
import { FilterIcon } from '@/assets/icons/filterIcon';
import { FilterFormSubmitValues } from '@/components/Settings/DataExtraction/ExtractionType/Hierarchy/types';
import type { FormInstance } from 'antd';
import * as S from './styles';

interface SettingsButtonProps {
	form: FormInstance;
	onSubmit: (values: FilterFormSubmitValues) => void;
	onClose: () => void;
}

export function SettingsButton({ form, onSubmit, onClose }: Readonly<SettingsButtonProps>) {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	function handleOnShow(): void {
		setIsOpen(true);
	}

	function handleOnClear(): void {
		setIsOpen(false);
		onClose();
	}

	function handleOnClose(): void {
		setIsOpen(false);
		onClose();
	}

	async function handleOnSubmit(): Promise<void> {
		const values = await form.validateFields();

		const data = {
			...values,
			...(values.creation_date && {
				start_date: values.creation_date[0],
				end_date: values.creation_date[1]
			})
		};

		onSubmit(data);
		setIsOpen(false);
	}

	return (
		<>
			<S.SettingsButton type="link" onClick={handleOnShow} icon={<S.FilterIconStyled as={FilterIcon} />} />
			<DrawerFilter open={isOpen} onSubmit={handleOnSubmit} onClear={handleOnClear} onClose={handleOnClose} />
		</>
	);
}
